<template>
    <!-- 礼品礼金申报 -->
    <div class="cash_container">
        <NavBar :title="guid?'廉洁上缴明细':'廉洁上缴申报'" :leftText="guid?true:false" :right-text="guid?undefined:'历史记录'" @onClickRight="onClickRight"/>
        <van-form label-width="30vmin" :readonly="readonly" @submit="onSubmit" validate-first @failed="failed">
            <van-field maxlength="15" autocomplete="off" v-model="form.personId" name="申报人工号" label="申报人工号" :placeholder="readonly?'':'必填'" :rules="[{required:true}]" @input="noChange"/>
            <van-field maxlength="15" autocomplete="off" v-model="form.personName" name="申报人姓名" label="申报人姓名" :placeholder="readonly?'':'必填'" :rules="[{required:true}]"/>
            <van-field maxlength="20" autocomplete="off" v-model="form.personDept" name="申报人部门" label="申报人部门" :placeholder="readonly?'':'必填'" :rules="[{required:true}]"/>
            <van-field maxlength="15" autocomplete="off" v-model="form.personPhone" name="手机" label="手机" :placeholder="readonly?'':'必填'" :rules="[{required:true}]"/>
            <van-field maxlength="10" autocomplete="off" v-model="form.money" type="number" name="礼金金额" label="礼金金额" :placeholder="readonly?'':'若无可填0'" :rules="[{required:true}]"/>
            <van-field maxlength="30" autocomplete="off" v-model="form.name" name="礼品名称" label="礼品名称" :placeholder="readonly?'':'若无可填无'" :rules="[{required:true}]"/>
            <van-field maxlength="30" autocomplete="off" v-model="form.value" name="礼品价值" label="礼品价值" :placeholder="readonly?'':'评估值，若无可填0'" :rules="[{required:true}]"/>
            <van-field maxlength="30" autocomplete="off" v-model="form.giverCompany" name="送礼单位" label="送礼单位" :placeholder="readonly?'':'若无可填无'" :rules="[{required:true}]"/>
            <van-field v-if="form.status=='已申请'||form.status=='已指派'" autocomplete="off" v-model="form.status" name="状态" label="状态"/>
            <van-field v-if="form.status=='已指派'" autocomplete="off" v-model="form.handleType" name="处理方式" label="处理方式"/>

            <FieldUpload :fileIds="appFileList" :disabled="readonly" @fileChange="appFileList=$event"/>
            <van-cell v-if="!readonly" center>
                <van-button type="info" round native-type="submit" loading-text="礼品礼金申报中。。。" :loading="loading">申报礼品礼金</van-button>
            </van-cell>
        </van-form>
    </div>
</template>
<script>
export default {
    data(){
        return{
            guid:'',
            isPC: window.innerWidth >= 769,
            readonly:false,
            loading:false,
            form:{},
            appFileList:[],
        }
    },
    mounted(){
        document.title='廉洁上缴申报'
        this.guid = this.$route.query.guid
        if(this.guid){
            this.readonly = true
            this.$http.get('/api/ts/v0.1/cashGift/'+this.guid)
            .then(res=>{
                this.form = res.data
                if(this.form.appFiles){
                    this.appFileList = this.form.appFiles.split(',')
                }else{
                    this.appFileList = []
                }
            })
        }else{
            this.$set(this.form,'personId',JSON.parse(localStorage.getItem('userInfo')).orgUserGuid)
            this.noChange()
        }
    },
    methods:{
        onSubmit(){
            this.Dialog.confirm({
                title:'警告',
                message:'请确认是否提交数据，提交后数据将不能修改。'
            }).then(()=>{
                this.loading = true
                this.form.appFiles = this.appFileList.join(',')
                this.$http.post('/api/ts/v0.1/cashGift/save',this.form)
                .then(res=>{
                    if (res.data >= 1) {
                        // this.$message.success('操作成功')
                        this.Dialog.alert({
                            title:'提醒',
                            message:'操作成功'
                        })
                        this.form = {}
                        this.appFileList = []
                    } else if(res.data) {
                        // this.$message.error('操作失败')
                        this.Dialog.alert({
                            title:'警告',
                            message:'操作失败'
                        })
                    }else{
                        // this.$message.error('您已经提交过了') 
                        this.Dialog.alert({
                            title:'警告',
                            message:'您已经提交过了'
                        })
                    }
                    this.loading = false
                })
                .catch((err)=>{
                    this.loading = false
                    // this.$message.error('操作失败')
                    this.Dialog.alert({
                        title:'警告',
                        message:'操作失败'
                    })
                })
            }).catch(()=>{

            })
            
        },
        failed(err){
            // this.$message.error('请填写'+err.errors[0].name)
            this.Dialog.alert({
                title:'警告',
                message:'请填写'+err.errors[0].name
            })
        },
        onClickRight(){
            this.$router.push({
                name: "cashGiftTable"
            });
        },
        noChange(){
            if(this.form.personId){
                this.$set(this.form,'personPhone',JSON.parse(localStorage.getItem('userInfo')).phone)
                this.$http.get('/api/ts/v0.1/common/getUserInfoByNo',{params:{userId:this.form.personId}})
                .then(res=>{
                    if(res.data){
                        this.$set(this.form,'personName',res.data.name)
                        this.$set(this.form,'personDept',res.data.deptName)
                        
                    }else{
                        this.$set(this.form,'personName','')
                        this.$set(this.form,'personDept','')
                    }
                })
                .catch((err)=>{
                    this.$set(this.form,'personName','')
                    this.$set(this.form,'personDept','')
                })
            }else{
                this.$set(this.form,'personName','')
                this.$set(this.form,'personDept','')
                this.$set(this.form,'personPhone','')
            }
            
        }
    }
}
</script>
<style scoped lang="less">
    .cash_container{
        width: 100%;
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        overflow-y: scroll;
    }
    table,tr,td{
        border:1px solid #D8D8D8;
        padding:5px;
    }
    tr{
        text-align: center;
        height:55px;
    }
    @media (min-width: 769px) {
        .cash_container{
            min-height: 100vh;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 40px 20px;
            box-sizing: border-box;
            position: relative;
            overflow-y: visible;
        }
        /deep/ .van-nav-bar{
            width: 100%;
            position: relative;
            background: #fff;
            border-bottom: 1px solid #999;
            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 4px;
                bottom: 4px;
                width: 4px;
                background-color: #027cfb;
                border-radius: 0 6px 6px 0;
            }
        }
        /deep/ .van-nav-bar__title{
            font-size: 22px;
            font-weight: 600;
            color: #333;
            text-align: left;
            position: absolute;
            left: 20px;
        }
        /deep/ .van-nav-bar__right{
            font-size: 20px;
            color: #0169ff;
            cursor: pointer;
            padding-right: 40px;
        }
        .van-form{
            width: 100%;
            padding: 30px 120px;
            box-sizing: border-box;
        }
        /deep/ .van-field .van-field__label{
            font-size: 18px;
            font-weight: 700;
            width: 230px !important;
            flex: none !important;
            -webkit-box-flex: 0 !important;
            -webkit-flex: none !important;
        }
        /deep/ .van-field__control{
            font-size: 18px;
            text-align: left;
        }
        ::v-deep .van-button{
            font-size: 18px;
        }
        /deep/ .van-cell{
            padding: 12px 16px;
        }
        /deep/.van-nav-bar__title{
            max-width:100%!important;
            width:100%!important;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
</style>